<!-- Ki, mikor, mit módosított a rendelésen. Csak akkor látszik, ha volt módosítás. -->
<div class="chl-card" *ngIf="loaded && items.length">
  <div class="chl-card__head">
    <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="#21252B" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="9"></circle><polyline points="12,7 12,12 15.5,14"></polyline></svg>
    <h3 class="chl-card__title">Módosítások</h3>
    <span class="chl-card__count">{{ items.length }}</span>
  </div>
  <div class="chl-item" *ngFor="let item of visible">
    <div class="chl-item__top">
      <span class="chl-item__who">{{ item.userName || 'Rendszer' }}</span>
      <span class="chl-item__when">{{ item.createdAt | date:'y. MMM d., HH:mm' }}</span>
    </div>
    <div class="chl-item__action">{{ item.note || actionLabel(item) }}</div>
    <div class="chl-change" *ngFor="let c of item.changes">
      <ng-container *ngIf="isProduct(c); else field">
        <span class="chl-change__label">Tétel</span>
        <span class="chl-change__val">{{ productText(c) }}</span>
      </ng-container>
      <ng-template #field>
        <span class="chl-change__label">{{ c.label }}</span>
        <span class="chl-change__val">
          <span class="chl-old">{{ c.old ?? '—' }}</span>
          <span class="chl-arrow">→</span>
          <span class="chl-new">{{ c.new ?? '—' }}</span>
        </span>
      </ng-template>
    </div>
  </div>
  <button type="button" class="chl-more" *ngIf="items.length > 5" (click)="showAll = !showAll">
    {{ showAll ? 'Kevesebb' : 'Összes (' + items.length + ')' }}
  </button>
</div>
